module.exports = __webpack_public_path__ + "img/page-10.9397fcde.jpg";